import config from '../../config';
import { getAuthHeaders } from './common';

const readResponseData = async (res) => {
    const text = await res.text();
    if (!text) return {};
    try {
        return JSON.parse(text);
    } catch {
        return text;
    }
};

const getErrorMessageFromData = (data, fallback) => {
    if (typeof data === 'string') return data || fallback;
    return data?.message || data?.detail || data?.title || fallback;
};

const sandboxApi = {
    convertToLive: async (practiceData) => {
        const res = await fetch(`${config.api.url}/sandbox/convert-to-live`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(practiceData),
        });

        const data = await readResponseData(res);
        if (!res.ok) {
            const error = new Error(getErrorMessageFromData(data, 'Failed to start your practice.'));
            error.status = res.status;
            error.data = data;
            throw error;
        }

        return data;
    },
};

export default sandboxApi;
